import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasDescriptionComponent } from './gas-description.component';
import { GasDividerModule } from '../gas-divider/gas-divider.module';

const COMPONENTS = [
  GasDescriptionComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    GasDividerModule,
  ],
})
export class GasDescriptionModule { }
